import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { cleanObj } from '../../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetParams } from '../../../../../../services/param.service';
import { AccountContactType } from '../../../../../../shared/types/modules/account';
import { AccountContactTypeProps } from './props';

export const useAccountContactType = ({
    data,
    onChangeData,
    onChangeFormik,
}: AccountContactTypeProps) => {
    const [typesContactPerson, setTypesContactPerson] = useState<ISelect[]>([]);
    const onSubmit = (data: AccountContactType) => {
        if (onChangeData) onChangeData(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'typeContactPerson',
            data?.typeContactPerson || ''
        );
        formik?.setFieldValue('isClient', data?.isClient || false);
        formik?.setFieldValue(
            'acceptsHabeasData',
            data?.acceptsHabeasData || false
        );
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.CONTACT_PERSON_TYPE).then((params) =>
            setTypesContactPerson(params)
        );
    }, []);

    return {
        formik,
        typesContactPerson,
    };
};
